import Cropper from 'cropperjs';
import { DirectUpload } from '@rails/activestorage';

// Users may select any common image format/size (AB#23983); the cropped
// export is bounded and the server optimizes every served rendition.
const MAX_UPLOAD_MEGABYTES = 20;
const MAX_UPLOAD_BYTES = MAX_UPLOAD_MEGABYTES * 1024 * 1024;
const MAX_CROP_EXPORT_PIXELS = 2048;

// Image bytes must not ride in the article form body: it is urlencoded, and
// Rack caps that at 4 MB, which ordinary photos exceed (AB#23983).
const DIRECT_UPLOAD_URL = '/rails/active_storage/direct_uploads';
// JPEG rather than the canvas default of lossless PNG, because
// Images::Optimization re-encodes every served rendition to WebP anyway.
const CROP_EXPORT_TYPE = 'image/jpeg';
const CROP_EXPORT_QUALITY = 0.92;

function isVideoExtension(filename) {
    const commonVideoExtensions = [
        '.mp4', '.webm', '.ogg', '.mov', '.avi', '.mkv', '.flv', '.wmv'
    ];

    const lowerCaseFilename = filename.toLowerCase();

    for (const extension of commonVideoExtensions) {
        if (lowerCaseFilename.endsWith(extension)) {
            return true;
        }
    }
    return false;
}

document.addEventListener("trix-attachment-add", function(event) {
  const attachment = event.attachment;

    //Check if attachment is a video before update the preview format
    if (attachment.file && isVideoExtension(attachment.file.name)) {

      // Set the HTML content for the editor preview
      attachment.setAttributes({
        content: `
        <img src="/default-video-thumbnail.jpg" />
        <figcaption class="attachment__caption">
        <span class="attachment__name">${attachment.file.name}</span>
        </figcaption>
          `
      });


      }

});


  
// direct_uploads.js
global.directUploadsInit = function () {
  addEventListener('direct-upload:initialize', (event) => {
    const { target, detail } = event;
    const { id, file } = detail;

    if (!$(`#direct-upload-${id}`)[0]) {
      target.insertAdjacentHTML(
        'beforebegin',
        `
        <div id="direct-upload-${id}" class="direct-upload direct-upload--pending">
          <div id="direct-upload-progress-${id}" class="direct-upload__progress" style="width: 0%"></div>
          <span class="direct-upload__filename">${file.name}</span>
        </div>
      `
      );
    }
  });

  addEventListener('direct-upload:start', (event) => {
    const { id } = event.detail;
    const element = document.getElementById(`direct-upload-${id}`);
    element.classList.remove('direct-upload--pending');
  });

  addEventListener('direct-upload:progress', (event) => {
    const { id, progress } = event.detail;
    const progressElement = document.getElementById(
      `direct-upload-progress-${id}`
    );
    progressElement.style.width = `${progress}%`;
  });

  addEventListener('direct-upload:error', (event) => {
    event.preventDefault();
    const { id, error } = event.detail;
    const element = document.getElementById(`direct-upload-${id}`);
    element.classList.add('direct-upload--error');
    element.setAttribute('title', error);
  });

  addEventListener('direct-upload:end', (event) => {
    const { id } = event.detail;
    const element = document.getElementById(`direct-upload-${id}`);
    element.classList.add('direct-upload--complete');
  });

  const previewImage = function (imageFile, fileInput) {
    const reader = new FileReader();

    reader.onload = (e) => {
      const placeholder = $('.js-image-preview-placeholder');
      const preview     = $('.image-preview');
      const image       = $('img.image-preview');

      placeholder.addClass('hidden');
      preview.removeClass('hidden');
      image.attr('src', e.target.result);

      if (image.hasClass('croppable')) {
        image[0].onload = function () {
          const width  = this.naturalWidth  || this.width;
          const height = this.naturalHeight || this.height;

          crop(image[0], { file: imageFile, input: fileInput }, width, height);
        };
      }
    };

    reader.readAsDataURL(imageFile);
  };

  function crop(image, { file, input }, width, height) {
    let cropper;
    // 'ready'/'cropend'/'zoom' can each start an async canvas export, and
    // toBlob callbacks resolve in any order — without this token an older
    // export finishing last would overwrite input.files with stale crop data.
    let cropGeneration = 0;

    const controls = $('.crop-zoom').removeClass('hidden');
    const enlarge  = controls.find('#zoomIn')[0];
    const shrink   = controls.find('#zoomOut')[0];

    const saveButton =  document.querySelector('#saveCroppedImage');

    function croppedCanvas() {
      return cropper.getCroppedCanvas({
        maxWidth: MAX_CROP_EXPORT_PIXELS,
        maxHeight: MAX_CROP_EXPORT_PIXELS,
      });
    }

    function onChange() {
      const generation = ++cropGeneration;

      croppedCanvas().toBlob(blob => {
        if (generation !== cropGeneration) return;

        const transfer = new ClipboardEvent("").clipboardData || new DataTransfer();
        const cropped  = new File([blob], file.name, { type: blob.type });

        transfer.items.add(cropped);
        input.files = transfer.files;
      });
    }

    function onEnlarge() {
      cropper.zoom(0.1);
      shrink.removeAttribute('disabled');
    }

    function onShrink() {
      cropper.zoom(-0.1);
    }

    function heroUploadFailed() {
      const errorMessage = document.querySelector('#hero-upload-error');

      if (errorMessage) { errorMessage.classList.remove('hidden'); }
      if (saveButton) { saveButton.removeAttribute('disabled'); }
    }

    function applyCroppedHero(blob, signedId) {
      const $hero      = $('img.blog-hero.cropped_image');
      const previewUrl = URL.createObjectURL(blob);

      $hero.one('load', () => URL.revokeObjectURL(previewUrl));
      $hero.attr('src', previewUrl);
      $('#article_hero_input').val(signedId);

      if (cropper.getImageData().aspectRatio >= 1.0) {
        $hero.addClass('landscape').removeClass('portrait');
      } else {
        $hero.addClass('portrait').removeClass('landscape');
      }

      $hero.removeClass('hidden');
      $('.image-preview-placeholder.blog-hero').addClass('hidden');
    }

    function saveCroppedImage() {
      const errorMessage = document.querySelector('#hero-upload-error');

      if (errorMessage) { errorMessage.classList.add('hidden'); }
      if (saveButton) { saveButton.setAttribute('disabled', ''); }

      croppedCanvas().toBlob(blob => {
        if (!blob) { return heroUploadFailed(); }

        const basename = (file.name || 'hero').replace(/\.[^.]+$/, '');
        const cropped  = new File([blob], `${basename}.jpg`, { type: blob.type });

        new DirectUpload(cropped, DIRECT_UPLOAD_URL).create((error, attributes) => {
          if (error) {
            console.error('Hero upload failed:', error);
            return heroUploadFailed();
          }

          applyCroppedHero(blob, attributes.signed_id);
          if (saveButton) { saveButton.removeAttribute('disabled'); }

          // Close only once the upload has actually succeeded; a failure keeps
          // the modal open with a visible error instead.
          global.modalClose('#hero-upload-modal');
        });
      }, CROP_EXPORT_TYPE, CROP_EXPORT_QUALITY);
    }

    function onDestroy() {
      // Invalidate any in-flight export so it can't clobber a newly
      // selected file after this cropper is torn down.
      cropGeneration++;
      cropper.destroy();
      image.removeEventListener('ready', onChange);
      image.removeEventListener('cropend', onChange);
      image.removeEventListener('zoom', onChange);
      input.removeEventListener('change', onDestroy);
      enlarge.removeEventListener('click', onEnlarge);
      shrink.removeEventListener('click', onShrink);
      shrink.setAttribute('disabled', '');
      if (saveButton){saveButton.removeEventListener('click', saveCroppedImage);}
    }

    input.addEventListener('change', onDestroy);
    // 'ready' swaps the (size-capped) cropped export into input.files as soon
    // as the cropper initializes, so submitting without touching the crop box
    // never uploads the raw original at full resolution.
    image.addEventListener('ready', onChange);
    image.addEventListener('cropend', onChange);
    image.addEventListener('zoom', onChange);
    enlarge.addEventListener('click', onEnlarge);
    shrink.addEventListener('click', onShrink);
    if (saveButton){saveButton.addEventListener('click', saveCroppedImage);}

    // Profile-picture headshots display as a circle (`.avatar` is `rounded-full`),
    // so they must crop to a 1:1 square. A circular overlay on a non-square crop box
    // renders as an oval, and a non-square crop looks zoomed/distorted once masked to
    // a circle (AB#25580). A square box also lets users resize to select the full area.
    // Article hero images keep their original landscape/portrait behavior.
    const isAvatar = image.classList.contains('avatar');

    cropper = new Cropper(image, {
      aspectRatio: isAvatar ? 1 : (width > height ? 1.77 : 0.66),
      background: false,
      cropBoxResizable: isAvatar,
      dragMode: 'move',
      minCanvasWidth: 200,
      minCanvasHeight: 200,
      viewMode: 1,
    });
  }

  var onFileSelected = function (evt) {
    const fileInput = evt.target;
    const files = Array.from(evt.target.files).map((file) => file.name);
    const placeholder =
      fileInput.getAttribute('data-placeholder') || fileInput.placeholder;

    // Store original placeholder
    fileInput.setAttribute('data-placeholder', placeholder);

    // Update current placeholder
    if (files.length === 1) {
      fileInput.placeholder = files[0].replace(/.*[\/\\]/, '');
    } else if (files.length > 1) {
      fileInput.placeholder = `${files.length} files`;
    } else {
      fileInput.placeholder = placeholder;
    }


    if (evt.target.files && evt.target.files[0])
    {

      var imgSize = evt.target.files[0].size;

      // Dimensions are no longer restricted client-side: the cropped export is
      // capped (see MAX_CROP_EXPORT_PIXELS) and the server resizes/optimizes
      // every rendition it serves (AB#23983).
      if (imgSize > MAX_UPLOAD_BYTES){
        var megabytes = (imgSize / (1024 * 1024)).toFixed(1);
        var sizeMsg = `Selected image is greater than ${MAX_UPLOAD_MEGABYTES} MB. Your file is ${megabytes} MB.`;
        // Clear the rejected file so it can't ride along on form submit.
        fileInput.value = '';
        fileInput.placeholder = placeholder;
        alert(sizeMsg);
      }else {
        previewImage(evt.target.files[0], fileInput);
      }
    }
  };

  $('input[type="file"]').each((index, el) =>
    $(el).on('change', onFileSelected)
  );

  $('video.protected').attr('controlsList', 'nodownload');
  $('video.protected, img.protected').bind('contextmenu', () => false);
};

$(document).on('turbolinks:load', directUploadsInit);